import { Dispatch, SetStateAction } from 'react';
import { IAsyncType, useAsync } from '.';

import { UserResponse } from '../../services/api';
import { cadabraService } from '../../services/services';

export interface IUsers<T> extends IAsyncType<T> {
  users: T;
  setUsers: Dispatch<SetStateAction<T>>;
}

const useUsers = (
  search?: string,
  showInactive: boolean = false,
  isAdmin?: boolean,
  names: string[] = [],
  skip: number = 0,
  limit: number = 25
): IUsers<UserResponse[]> => {
  const { data, setData, loading, setLoading, parameters, setParameters } = useAsync<
    UserResponse[]
  >(cadabraService.getUsers, [], [search, showInactive, isAdmin, names, skip, limit]);
  return {
    users: data,
    setUsers: setData,
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useUsers;
